import { c as _c } from "react/compiler-runtime";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { ImageScale } from "@/helpers/image.helpers";
import type { MemesDropMedia } from "./memesDropPanelTypes";
interface MemesDropArtworkHeroProps {
  readonly artworkMedia?: MemesDropMedia | null | undefined;
}
export function MemesDropArtworkHero(t0) {
  const $ = _c(4);
  const {
    artworkMedia
  } = t0;
  let t1;
  if ($[0] !== artworkMedia) {
    t1 = artworkMedia && <div className="tw-mx-auto tw-flex tw-w-full tw-items-center tw-justify-center md:tw-max-w-4xl"><div className="tw-relative tw-h-[clamp(18rem,75vw,calc(100dvh-8rem))] tw-w-full lg:tw-h-[95vh]"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} imageScale={ImageScale.AUTOx1080} fillVideoContainer={true} /></div></div>;
    $[0] = artworkMedia;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tw-flex tw-w-full tw-flex-col lg:tw-min-h-screen"><div className="tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-4 sm:tw-px-6 lg:tw-flex-1 lg:tw-py-8 xl:tw-px-20">{t1}</div></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}